/**
 * Declarative status → Tag colour lookup: pass the per-status colours once and get the
 * `(status?) => color` function every grid column and Manage banner shares. Unknown or unset
 * statuses fall back to `"default"`.
 */
export const createStatusColorMap =
  <T extends string = string>(
    colors: { [status in T]?: string },
    fallback = "default",
  ) =>
  (status?: T): string =>
    (status && colors[status]) || fallback;

export function softColor(str: string): string {
  str = str || "";
  let stringUniqueHash = Array.from(str).reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);
  return `hsl(${stringUniqueHash % 360}, 50%, 50%)`;
}

export function hexToRgbA(hex: string, alpha = 1) {
  let c: any;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      `,${alpha})`
    );
  }

  return hex;
}
